import { injectGlobal } from "styled-components";

injectGlobal`
    .hidden-context {
        display: none;
    }
`;
